export type View = "showcase" | "app" | "login";
export type Page = "schedule" | "dispatch" | "progress";

interface UIStoreLike {
  showFeedbackPrompt(): void;
}

export interface AppStore {
  view: View;
  page: Page;
  visited: Set<Page>;
  enterApp(): void;
  exitApp(): void;
  goLogin(): void;
  go(p: Page): void;
}

export function createAppStore(): AppStore {
  return {
    view: "showcase",
    page: "schedule",
    visited: new Set<Page>(["schedule"]),
    enterApp() {
      this.view = "app";
      window.scrollTo({ top: 0, behavior: "instant" });
    },
    exitApp() {
      this.view = "showcase";
    },
    goLogin() {
      this.view = "login";
    },
    go(p: Page) {
      this.page = p;
      this.visited.add(p);
      if (this.visited.size >= 2) {
        const ui = (window as unknown as { Alpine: { store(name: string): UIStoreLike } }).Alpine.store("ui");
        setTimeout(() => ui.showFeedbackPrompt(), 1200);
      }
    },
  };
}
